<template>
    <div class="row">
        <div class="col-md-12">
            <table id="example2" class="table table-bordered table-hover data-tables" data-options='{ "paging": false; "searching":false}'>
                <thead>
                    <tr>
                        <th>S/N</th>
                        <th>Package</th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th>Upgrade Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loading">
                        <td colspan="6">
                            <b-skeleton-table
                                :rows="3"
                                :columns="6"
                                :table-props="{ bordered: true, striped: true }"
                            ></b-skeleton-table>
                        </td>
                    </tr>
                    <template v-else>
                        <tr v-if="packagePayments.length == 0">
                            <td colspan="6">
                                <div class="alert alert-info text-center">
                                    There are no upgrade History
                                </div>
                            </td>
                        </tr>
                        <template v-else>
                            <tr v-for="user,i in packagePayments" :key="i">
                                <!--<td>{{ (paidUsersPerPage * (paidUsersCurrentPage - 1)) +( ++i) }}</td>-->
                                <td>{{ ++i }}</td>
                                <td>{{ user.package_name }}</td>
                                <td>{{ user.status }}</td>
                                <td>₦{{ user.registration_value?.toLocaleString('en-US') }}</td>

                                <td>{{ user.created_at }}</td>
                            </tr>
                        </template>
                        
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { mapActions} from 'vuex';
    export default {
        name:"stockist-package-payment",

        props:{
            user:{
                type:Object,
                required:true
            }
        },

        data(){
            return {
                loading:false,
                packagePayments:[]
            }
        },

        computed:{

        },

        created(){
            if(this.packagePayments.length == 0){
                this.loading = true
                this.getStockistPackagePayment(this.user.user_uuid).then((res)=>{
                    if(res && res.status == 200){
                        this.packagePayments = res.data.data.data
                    }
                    this.loading=false
                })
            }
        },

        methods:{
            ...mapActions("paymentStore",['getStockistPackagePayment'])
        }
    }
</script>